export default __webpack_public_path__ + "static/media/portadavideoplanificacion3.6ec02801.png";